// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-feedback[data-v-4f5d571a] {\n  text-align: center;\n}\n.chat-feedback__offer-text[data-v-4f5d571a] {\n  margin-bottom: 5px;\n  font-size: 12px;\n}\n.chat-feedback__draft-invoice[data-v-4f5d571a] {\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
